// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-form-container h2 {
  font-size: 1rem;
  color: #374151;
  font-weight: 500;
  line-height: normal !important;
}
.case-form-container .court-edit-case {
  margin-bottom: 0rem !important;
}
.case-form-container .court-type-selection .new-court-case {
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 1rem;
}
.case-form-container .court-type-selection .new-court-case .main-title-add-case {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  color: #111827;
  letter-spacing: -0.025em;
}
@media (max-width: 768px) {
  .case-form-container .court-type-selection .new-court-case .main-title-add-case {
    font-size: 1.5rem;
  }
}
.case-form-container .court-type-selection .new-court-case .two-court-cases {
  display: inline-flex;
  background: #f9fafb;
  border-radius: 10px;
  padding: 4px;
  gap: 5px;
  border: 1px solid #e5e7eb;
}
.case-form-container .court-type-selection .new-court-case .two-court-cases label {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 18px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
  background-color: transparent;
  color: #6b7280;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  position: relative;
}
.case-form-container .court-type-selection .new-court-case .two-court-cases label input[type=radio] {
  display: none;
}
.case-form-container .court-type-selection .new-court-case .two-court-cases label:hover:not(.active) {
  color: #374151;
  background-color: #ffffff;
  border-color: #d1d5db;
}
.case-form-container .court-type-selection .new-court-case .two-court-cases label.active {
  background-color: var(--primary-color);
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(59, 130, 246, 0.3);
}
@media (max-width: 768px) {
  .case-form-container .court-type-selection .new-court-case .two-court-cases label {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
  }
}
@media (max-width: 768px) {
  .case-form-container .court-type-selection .new-court-case .two-court-cases {
    width: 100%;
    margin-top: 1rem;
  }
}
@media (max-width: 768px) {
  .case-form-container .court-type-selection .new-court-case {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
}
.case-form-container .form-content {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 768px) {
  .case-form-container .form-content {
    padding: 1.5rem;
  }
}
@media (max-width: 768px) {
  .case-form-container {
    padding: 1.5rem;
  }
}

.case-form-container-alt {
  padding: 2rem;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.case-form-container-alt .court-type-selection {
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
}
.case-form-container-alt .court-type-selection .new-court-case .main-title-add-case {
  font-size: 1.75rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1.5rem;
}
.case-form-container-alt .court-type-selection .new-court-case .two-court-cases {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e5e7eb;
  position: relative;
}
.case-form-container-alt .court-type-selection .new-court-case .two-court-cases label {
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
  position: relative;
  background: none;
  border-radius: 0;
}
.case-form-container-alt .court-type-selection .new-court-case .two-court-cases label input[type=radio] {
  display: none;
}
.case-form-container-alt .court-type-selection .new-court-case .two-court-cases label:hover:not(.active) {
  color: #374151;
  background-color: #f9fafb;
}
.case-form-container-alt .court-type-selection .new-court-case .two-court-cases label.active {
  color: var(--primary-color);
  border-bottom-color: var(--primary-color);
  background-color: #eff6ff;
}
.case-form-container-alt .form-content {
  background: #ffffff;
  padding: 2rem 0;
}`, "",{"version":3,"sources":["webpack://./src/forms/CaseForm/CaseForm.scss"],"names":[],"mappings":"AAEE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,8BAAA;AADJ;AAKE;EACE,8BAAA;AAHJ;AAQI;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;AANN;AAQM;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,wBAAA;AANR;AAQQ;EAPF;IAQI,iBAAA;EALR;AACF;AAQM;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;EACA,yBAAA;AANR;AAQQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;AANV;AAQU;EACE,aAAA;AANZ;AASU;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAPZ;AAUU;EACE,sCAAA;EACA,cAAA;EACA,6CAAA;AARZ;AAWU;EA/BF;IAgCI,oBAAA;IACA,kBAAA;EARV;AACF;AAWQ;EA7CF;IA8CI,WAAA;IACA,gBAAA;EARR;AACF;AAWM;EArEF;IAsEI,sBAAA;IACA,uBAAA;IACA,gBAAA;EARN;AACF;AAYE;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAVJ;AAgBI;EAdF;IAeI,eAAA;EAbJ;AACF;AAgBE;EAhHF;IAiHI,eAAA;EAbF;AACF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AAdF;AAgBE;EACE,gCAAA;EACA,mBAAA;EACA,sBAAA;AAdJ;AAiBM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAfR;AAkBM;EACE,aAAA;EACA,MAAA;EACA,gCAAA;EACA,kBAAA;AAhBR;AAkBQ;EACE,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAhBV;AAkBU;EACE,aAAA;AAhBZ;AAmBU;EACE,cAAA;EACA,yBAAA;AAjBZ;AAoBU;EACE,2BAAA;EACA,yCAAA;EACA,yBAAA;AAlBZ;AAyBE;EACE,mBAAA;EACA,eAAA;AAvBJ","sourcesContent":[".case-form-container {\n\n  h2 {\n    font-size: 1rem;\n    color: #374151;\n    font-weight: 500;\n    line-height: normal !important;\n\n  }\n\n  .court-edit-case {\n    margin-bottom: 0rem !important;\n  }\n\n  .court-type-selection {\n\n    .new-court-case {\n      display: flex;\n      justify-content: end;\n      align-items: center;\n      margin-bottom: 1rem;\n\n      .main-title-add-case {\n        font-size: 1.8rem;\n        font-weight: 700;\n        margin: 0;\n        color: #111827;\n        letter-spacing: -0.025em;\n\n        @media (max-width: 768px) {\n          font-size: 1.5rem;\n        }\n      }\n\n      .two-court-cases {\n        display: inline-flex;\n        background: #f9fafb;\n        border-radius: 10px;\n        padding: 4px;\n        gap: 5px;\n        border: 1px solid #e5e7eb;\n\n        label {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          padding: 8px 18px;\n          font-size: 0.9rem;\n          font-weight: 600;\n          cursor: pointer;\n          border-radius: 8px;\n          background-color: transparent;\n          color: #6b7280;\n          transition: all 0.2s ease;\n          border: 2px solid transparent;\n          position: relative;\n\n          input[type=\"radio\"] {\n            display: none;\n          }\n\n          &:hover:not(.active) {\n            color: #374151;\n            background-color: #ffffff;\n            border-color: #d1d5db;\n          }\n\n          &.active {\n            background-color: var(--primary-color);\n            color: #ffffff;\n            box-shadow: 0 1px 3px rgba(59, 130, 246, 0.3);\n          }\n\n          @media (max-width: 768px) {\n            padding: 0.6rem 1rem;\n            font-size: 0.85rem;\n          }\n        }\n\n        @media (max-width: 768px) {\n          width: 100%;\n          margin-top: 1rem;\n        }\n      }\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n        align-items: flex-start;\n        text-align: left;\n      }\n    }\n  }\n\n  .form-content {\n    background-color: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 20px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n    width: 70%;\n    margin-left: auto;\n    margin-right: auto;\n    // display: flex;\n    // flex-direction: column;\n    // justify-content: center;\n    // align-items: center;\n\n    @media (max-width: 768px) {\n      padding: 1.5rem;\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 1.5rem;\n  }\n}\n\n// Alternative cleaner tab style\n.case-form-container-alt {\n  padding: 2rem;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n\n  .court-type-selection {\n    border-bottom: 1px solid #e5e7eb;\n    margin-bottom: 2rem;\n    padding-bottom: 1.5rem;\n\n    .new-court-case {\n      .main-title-add-case {\n        font-size: 1.75rem;\n        font-weight: 600;\n        color: #111827;\n        margin-bottom: 1.5rem;\n      }\n\n      .two-court-cases {\n        display: flex;\n        gap: 0;\n        border-bottom: 2px solid #e5e7eb;\n        position: relative;\n\n        label {\n          padding: 0.75rem 1.5rem;\n          font-weight: 600;\n          color: #6b7280;\n          cursor: pointer;\n          border-bottom: 2px solid transparent;\n          transition: all 0.2s ease;\n          position: relative;\n          background: none;\n          border-radius: 0;\n\n          input[type=\"radio\"] {\n            display: none;\n          }\n\n          &:hover:not(.active) {\n            color: #374151;\n            background-color: #f9fafb;\n          }\n\n          &.active {\n            color: var(--primary-color);\n            border-bottom-color: var(--primary-color);\n            background-color: #eff6ff;\n          }\n        }\n      }\n    }\n  }\n\n  .form-content {\n    background: #ffffff;\n    padding: 2rem 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
